<template>
    <div class="main-body">
        <div class="header">投诉建议</div>
        <div class="out">
            <div class="search2">

              <div style="float: right;">

                <el-select v-model="status" clearable placeholder="请选择状态" style="width:120px;margin-right:10px">
                  <el-option
                      v-for="item in statusValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>

                <el-select v-model="type" clearable placeholder="请选择类型" style="width:120px;margin-right:10px">
                  <el-option
                      v-for="item in typeValue"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
                </el-select>

                <el-date-picker style="margin-right: 10px;width:250px;" title="起止时间" size="mini"
                                v-model="startEndTime"
                                type="daterange"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间">
                </el-date-picker>

                <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>

              </div>
              <div style="clear: both;"></div>
            </div>

            <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border>

                <el-table-column prop="user.name" label="老人名称" width="100"></el-table-column>
                <el-table-column prop="user.phone" label="手机号" width="120"></el-table-column>
                <el-table-column prop="type" :formatter="statusTitle" label="类型" width="100"></el-table-column>
                <el-table-column prop="remarks" label="内容" ></el-table-column>

              <el-table-column fixed="right" label="处理状态" width="200">
                <template slot-scope="scope">
                  <span v-if="scope.row.status==0" >未处理</span>
                  <span v-if="scope.row.status==1" >已处理</span>
                </template>
              </el-table-column>

              <el-table-column prop="createTime" :formatter="timefilter" width="200" label="创建时间"></el-table-column>
                <el-table-column fixed="right" label="操作" width="200">
                    <template slot-scope="scope">
                        <el-button v-if="scope.row.status!=1" type="primary" size="mini" @click="handle(scope.$index, scope.row)">处理</el-button>
                        <el-button v-else type="success" size="mini" @click="handleLook(scope.row)">查看</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="page">
                <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
                <div style="float: left;">
                    <el-pagination small
                            background
                            layout="prev, pager, next"
                            :total="totalItems"
                            :page-size="20"
                            :current-page.sync="currentPage"  @current-change="current_change">
                    </el-pagination>
                </div>
                <div style="clear: both;"></div>
            </div>

        </div>

    </div>
</template>

<script>

    import {timeStr,timefilters} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: "Role",
        data(){
            return{
                tableLoading:false,

                tableData:[],
                totalItems: 0,
                pageSize:20,
                currentPage:1,

                th:0,


              statusValue:[
                  {value:-1,label:'全部状态'},
                {value:0,label:'待处理'},
                {value:1,label:'已处理'}
              ],
              status:0,

              typeValue:[
                  {value:-1,label:'全部类型'},
                {value:0,label:'建议'},
                {value:1,label:'投诉'}
              ],
              type:-1,

              startEndTime:[],

            }
        },
        created(){
            this.init();
            this.th = this.$store.state.tableHeight;
        },
        components:{

        },
        watch: {
            //监听全局变量
            '$store.state.tableHeight' : function(val){
                this.th = val;
            },
        },
        methods:{
            init(){

              const end = new Date();
              const start = new Date(end - 1000 * 60 * 60 * 24 * 30);
              this.startEndTime = [start, end];

              this.getList(false);

            },

            handle(index,row){
                this.$prompt('请输入操作备注', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern:'',
                    inputErrorMessage: '',
                    inputType:'textarea'
                }).then(({ value }) => {
                    this.$confirm('是否处理此条数据?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).then(() => {

                        this.$axios({
                            method: 'post',
                            url: this.$shopUrl+"Complaint/Dispose",
                            data:{
                                timeStr:timeStr,
                                sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                                staffCode:getStaffCode(),
                                complaintCode:row.complaintCode,
                                disposeRemark:value
                            }
                        }).then(
                            (response) => {
                                if (response.data.error == 0) {
                                    this.getList();
                                }else if(response.data.error == 1){
                                    this.$message.error(response.data.message)
                                }
                            }
                        )

                    }).catch(e=>e)
                }).catch(() => {
                    //this.$message({type: 'info', message: '取消输入'});
                });
            },
            handleLook(row){
                this.$alert(row.disposeRemark, '处理详情', {
                    confirmButtonText: '确定',
                    callback: () => {}
                });
            },

            //日期格式
            timefilter(row, column, cellValue){
                return timefilters(cellValue)
            },

            current_change:function(currentPage){
                this.currentPage = currentPage;
                this.getList();
            },
            getList(isSearch){
              if(isSearch)this.currentPage=1

              //if(this.status == '')this.status = -1;
              //if(this.type =='')this.type=-1;

                var _this=this
                this.tableLoading=true
                let data={
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode: getStaffCode(),

                    pageIndex:this.currentPage,
                    pageSize:this.pageSize,

                  startTime: timefilters(this.startEndTime[0]),
                  endTime: timefilters(this.startEndTime[1]),

                  status:this.status,
                  type:this.type,

                }

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"Complaint/PageList",
                    data: data
                }).then( (response)=> {
                    _this.tableLoading=false
                    if(response.data.error == 0){
                        this.tableData = response.data.data.list;
                        this.totalItems = response.data.data.total;
                    }else if(response.data.error == 1){
                      this.$message.error(response.data.message)
                    }
                }).catch(function (error) {
                    _this.tableLoading=false
                    console.log(error);
                });
            },

            statusTitle(row, column, cellValue){
                 return this.allStatus(cellValue,['建议','投诉']);
            },
            allStatus(row,status){
                for(var i in status){
                    if(i==row){
                        return status[i]
                    }
                }
                return "其它";
            }



        }
    }
</script>

<style scoped>

</style>
